import Fab from '@material-ui/core/Fab/Fab';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import React from 'react';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent/index';
import styles from './styles';
import ViewListIcon from '@material-ui/icons/ViewList';
import ItemTypeChip from './ItemTypeChip';
import Grid from '../../../Common/Grid/index';
import { CONFIRM_DIALOG, TASK_PROFILE_DIALOG } from '../../../../redux/constants/dialogs';

const COLUMNS = [
  { name: 'name', title: 'Name' },
  { name: 'itemTypes', title: 'Items' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'name', width: 150 },
  { columnName: 'action', width: 50 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    case 'itemTypes':
      return (value || []).map((itemType) => {
        return (<ItemTypeChip key={itemType.id} itemType={itemType} count={itemType.quantity} color/>);
      });
    default :
      return value;
  }
};

class TaskProfilesGrid extends React.Component {

  handleAdd = () => {
    this.handleEdit({ itemTypes: [] });
  };

  handleEdit = (taskProfile) => {
    console.log('profile', taskProfile);
    this.props.showDialog(TASK_PROFILE_DIALOG, { taskProfile });
  };

  handleRemove = (profile) => {
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to remove this task profile?',
        onConfirm: () => {
          this.props.onRemove(profile).then(() => {
            resolve();
          });
        },
        onReject: reject,
        confirmColor: 'secondary',
      });
    });
  }

  render() {
    const { data, fetch } = this.props;

    const buttons = [<Fab
      key="add"
      style={styles.addItem}
      color="secondary"
      onClick={this.handleAdd}>
      <AddIcon/>
    </Fab>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent}
      data={data}
      fetch={fetch}
      onEdit={this.handleEdit}
      onRemove={this.handleRemove}
      noDataCellComponent={getNoDataCellComponent(<ViewListIcon style={styles.noData}/>, 'task profiles')}
    />);
  }
}

TaskProfilesGrid.propTypes = {
  data: PropTypes.object,
  showDialog: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default TaskProfilesGrid;




// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfilesGrid/index.js